import { Financials } from './financials.model';

export class FinancialsEnergy {
	public electric: Financials;
	public diesel: Financials;
	public gas: Financials;
	public electricComp: Financials;
	public feedbacks?: string;
}
